<script setup lang="ts">
import type {SerializedEditorState, SerializedLexicalNode} from '@payloadcms/richtext-lexical/lexical'
import {convertLexicalToHTML, defaultHTMLConverters} from '@payloadcms/richtext-lexical/html'
import {getBlockComponent, Media} from './blocks'

const props = defineProps<{
  data: SerializedEditorState | null | undefined
}>()

const nodes = computed(() => props.data?.root?.children ?? [])

// Convert a single node to HTML (for non-custom nodes)
function nodeToHtml(node: SerializedLexicalNode): string {
  if (!props.data?.root) return ''

  return convertLexicalToHTML({
    converters: defaultHTMLConverters,
    data: {root: {...props.data.root, children: [node]}} as SerializedEditorState,
  })
}
</script>

<template>
  <div class="prose prose-img:mx-auto prose-img:rounded-lg prose-img:border prose-img:border-gray-200">
    <template v-for="(node, i) in nodes" :key="i">
      <!-- @vue-ignore -->
      <Media v-if="node.type === 'upload'" :node="node" />

      <!-- Block: dynamic Vue component -->
      <NuxtErrorBoundary v-else-if="node.type === 'block' && getBlockComponent((node as any).fields?.blockType)">
        <component :is="getBlockComponent((node as any).fields.blockType)" v-bind="(node as any).fields" />
      </NuxtErrorBoundary>

      <!-- Everything else: HTML -->
      <div v-else v-html="nodeToHtml(node)" />
    </template>
  </div>
</template>
